import { DataItemConfiguration } from "webportalclient";
import { ConfigurableDataItemIds } from "../misc/api/ApiConfigurableDataItems";
import { DataItemImportance } from "../misc/api/apiTypes";

export const isColumnHidden = (itemId: ConfigurableDataItemIds, dataItemConfigurationCollection: DataItemConfiguration[]) => {
    if (dataItemConfigurationCollection === null)
        return false;

    return dataItemConfigurationCollection.find(x => x.configurableDataItemId == itemId).importanceId === DataItemImportance.NotApplicable;
}
